import { useTranslation } from 'react-i18next';

import { AgreementLink, AppFooter, Wrapper } from './footer.styles';

const CURRENT_YEAR = new Date().getFullYear();

const RGS_PERSONAL_AGREEMENT =
  'https://www.rgs.ru/about/politika-o-poryadke-obrabotki-personalnykh-dannykh ';

const RGS_USER_AGREEMENT = 'https://www.rgs.ru/about/ps-service-digital-agent ';

export const Footer = () => {
  const { t } = useTranslation('COMMON');

  return (
    <Wrapper>
      <AppFooter>
        <span>{t('footer.address', { currentYear: CURRENT_YEAR })}</span>
        <AgreementLink
          href={RGS_PERSONAL_AGREEMENT}
          target='_blank'
        >
          {t('footer.agreement')}
        </AgreementLink>
        <AgreementLink
          href={RGS_USER_AGREEMENT}
          target='_blank'
        >
          {t('footer.termsOfUse')}
        </AgreementLink>
      </AppFooter>
    </Wrapper>
  );
};
